import { useParams } from 'react-router';

import { SIMULATION_TYPES } from '~constants/simulations';

export const useKind = () => {
  const { kind } = useParams();
  return SIMULATION_TYPES[kind];
};
